<script>
  import { VimeoPlayer } from 'svelte-vimeo-player';

  import Squared from '/Atoms/Squared'
  import IconPlayGreen from '/Icons/IconPlayGreen'

  import { lighboxSlideActive } from '/stores.js';

  export let collection = []

  let items = []

  const patterns = {
     1: "L",
     2: "LL",
     3: "SSS",
     4: "LMML",
     5: "LSSSL",
     6: "LMMMML",
     7: "LMMSSSL",
     8: "LSSSSSSL",
     9: "LMMSSSMML",
    10: "LSSSMMSSSL",
    11: "LSSSSSSSSSL",
    12: "LSSSMMSSSMML",
    13: "LSSSMMSSSSSSL",
    14: "LSSSMMSSSMMMML",
    15: "LSSSMMSSSSSSMML",
    16: "LSSSMMSSSSSSSSSL",
    17: "LSSSSSSSSSSSSSSSL",
    18: "LSSSMMSSSSSSMMSSSL",
    19: "LSSSMMSSSSSSSSSSSSL",
    20: "LSSSMMSSSSSSMMSSSMML",
    21: "LSSSMMSSSSSSMMSSSSSSL",
    22: "LSSSMMSSSMMSSSMMSSSMML",
    23: "LSSSMMSSSMMSSSMMSSSSSSL",
    24: "LSSSSSSSSSMMSSSMMSSSSSSL",
    25: "LSSSMMSSSSSSMMSSSMMMMSSSL",
    26: "LSSSMMSSSSSSMMSSSMMSSSSSSL",
    27: "LSSSMMSSSMMSSSMMSSSMMSSSMML",
    28: "LSSSMMSSSMMSSSMMSSSMMSSSSSSL",
    29: "LSSSMMSSSMMSSSSSSSSSMMSSSSSSL",
    30: "LSSSSSSSSSMMSSSSSSSSSMMSSSSSSL",
    31: "LSSSSSSMMMMSSSSSSSSSMMMMSSSSSSL",
    32: "LSSSSSSMMMMSSSSSSSSSSSSMMSSSSSSL",
  }
  
  $: {
    items = collection.map( c => {
      if (c.mediaImage) {
        return {
          type: "image",
          url: c.mediaImage[0].url,
          text: c.title || "",
          credits: c.credits || "",
          id: c.mediaImage[0].id
        } 
      }
      if (c.videoSource) {
        return {
          type: "vimeo",
          url: c.videoSource[0].vimeoUrl,
          text: c.title || "",
          credits: c.credits || "",
          id: c.videoSource[0].id
        }
      }
    })
  
    /*
    for (let i = 0; i<31; i++) { // Math.ceil(Math.random()*12)
      items.push(    {
        type: "image",
        url: `https://picsum.photos/${Math.round(Math.random()*600+100)}/${Math.round(Math.random()*600+100)}`,
        text: Math.random() > 0.5 ? "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. " : "",
        credits: "Photo: Laura Fiorio, transmediale, CC BY-SA 4.0. Some rights reserved"
      })
    }
    */
  


    // map letters to items
    items = items.map( (item, index) => {
      // take letter from patterns object, or use simple algorithm if there is no pattern
      const letter = patterns[items.length] ? patterns[items.length].substr(index,1) 
          : index == 0 ? "L" : items.length - (2+items.length%3) > index ? "S" : "M"
      return {
        ...item,
        letter,
        index,
      }
    })
    
  }

  const onClickItem = item => {
    console.log(item, items)
    $lighboxSlideActive = items.map( i => ({...i, active: item.id === i.id }) )
  }

  // console.log(collection, items)

</script>

<ol class="gallery">
  {#each items as item}
    <li class="item {item.letter}" title={item.text} on:click={ () => onClickItem(item)}>
      <Squared aspectRatio={ item.letter == "L" ? 0.5 : item.letter == "M" ? 0.5 : 1 }>
        {#if item.type == "image"}
          <img src={item.url} alt={item.text} loading="lazy" />
        {/if}
        {#if item.type == "vimeo"}
          <div class="video">
            <VimeoPlayer
              elementKey="gallery"
              videoId={item.url}
              options={{
                responsive: true,
                controls: false,
              }}
            />
            <div class="icon-play">
              <IconPlayGreen />
            </div>
          </div>
        {/if}
      </Squared>
    </li>
  {/each}
</ol>


<style lang="scss">

  .gallery {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-right: -10px;
  }

  .item {
    border-radius: 20px;
    flex: 50%;
    margin-bottom: 20px;
    margin-right: 10px;
    margin-left:  10px;
    box-sizing: border-box;
    overflow: hidden;

    cursor: pointer;

    &.L {
      flex: calc(100% - 20px);
    }

    &.M {
      flex: calc(50% - 10px - 10px - 10px);
    }

    &.S {
      flex: calc(33.3333% - 10px - 10px - 10px - 10px);
    }

    @include media-1col-only {
      flex: 100% !important;
    }
  }

  .video {
    pointer-events: none;
    position: relative;
    .icon-play {
      position: absolute;
      left: 50%;
      top:50%;
      transform: translateX(-50%) translateY(-45%);
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
</style>


